import React, { useState } from 'react';
import { SlidingScale } from '../../survey-tools/likert-scales';
import { Button, Typography } from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function RationalityScale({ instanceId,nextTask }) {
    const [sliderValue, setSliderValue] = useState(50);
    const [sliderMoved, setSliderMoved] = useState(false); // State to track if the slider has been moved
    const [showDialog, setShowDialog] = useState(false);

    const handleChange = (newValue) => {
        if (!sliderMoved) setSliderMoved(true); // Update sliderMoved to true on first interaction
        setSliderValue(newValue);
    };

    const handleNext = () => {
        if (!sliderMoved) { // Check if the slider has never been moved
            setShowDialog(true); // Show the dialog if the slider hasn't been moved
        } else {
            console.log("Saving Rationality Value:", sliderValue);
            console.log("Instance ID:", instanceId);
            nextTask({ data: { [instanceId]: sliderValue } });
        }
    };

    const question = (
    <div>
        <Typography gutterBottom>
            On a scale from 0-100, indicate the <strong>Rationality</strong> of your current state, where 0 is emotional and 100 is rational.
        </Typography>
        <Typography gutterBottom style={{ marginTop: '1em' }}>
            <strong>Emotional</strong> refers to states of feeling; emotional states.
        </Typography>
        <Typography gutterBottom>
            <strong>Rational</strong> refers to states related to making decisions or inferences, or thinking in orderly, rational ways.
        </Typography>
        <Typography gutterBottom style={{ marginTop: '1em' }}>
            For example, states that are <strong>emotional</strong> are <strong>happiness, sorrow, rage,</strong> and <strong>hope</strong>, while states that are <strong>rational</strong> are <strong>reason, decision, planning,</strong> and <strong>self-control</strong>.
        </Typography>
    </div>

    );


    return (
        <PageContainer>

        <div>
            <SlidingScale 
                question={question} 
                leftLabel="Emotional" 
                rightLabel="Rational" 
                handleUpdate={handleChange}
            />
            <Button variant="contained" onClick={handleNext}>Next</Button>
            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    nextTask({ data: { [instanceId]: sliderValue } });
                }}
            />
                    </div>

        </PageContainer>
    );
};


const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(RationalityScale);

